import { IUserStore } from './types';

export const SET_USER = 'SET_USER';
export type SET_USER = typeof SET_USER;

export const SET_LOGIN_ERROR = 'SET_LOGIN_ERROR';
export type SET_LOGIN_ERROR = typeof SET_LOGIN_ERROR;

export interface ISetUser {
  user: IUserStore;
  type: SET_USER;
}

export interface ISetLoginError {
  msg: string;
  type: SET_LOGIN_ERROR;
}

export type IUserActions = ISetUser | ISetLoginError;



// WEBPACK FOOTER //
// ./src/services/user/actionTypes.ts